import { jotaiStore } from 'init/jotai';
import { i18nKeys, translationStateAtom } from 'locales';

type Notification = { title: string; color: string; message: string };

function show(notification: Notification): void {
  void import('@mantine/notifications').then(({ notifications }) =>
    notifications.show(notification),
  );
}

type NotificationPayload = {
  text?: string;
  data?: unknown;
};

export function success({ text, data }: NotificationPayload = {}): void {
  const { t } = jotaiStore.get(translationStateAtom);

  show({
    title: t(i18nKeys.SUCCESS),
    color: 'green',
    message: `${text ? t(text) : ''}\n${typeof data === 'string' ? data : ''}`,
  });
}

type WarningPayload = {
  messages?: string[];
};

export function warning({ messages = [] }: WarningPayload = {}): void {
  if (messages.length === 0) return;

  const { t } = jotaiStore.get(translationStateAtom);

  show({
    title: t(i18nKeys.WARNING),
    color: 'orange',
    message: messages.join('\n'),
  });
}

export function error({ text, data }: NotificationPayload = {}): void {
  if (!data && !text) return;

  const { t } = jotaiStore.get(translationStateAtom);

  const concatenatedMessages = Array.isArray(data) ? data.join('\n') : null;

  show({
    title: t(i18nKeys.ERROR.ERROR),
    color: 'red',
    message: `${text ? t(text) : ''}\n${typeof data === 'string' ? data : concatenatedMessages}`,
  });
}
